import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=85f52e72&scoped=true"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"
import style0 from "./select-input.vue?vue&type=style&index=0&id=85f52e72&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f52e72",
  null
  
)

export default component.exports